export default class Exception extends Error {
	code = null;

	constructor(message, name, code = null) {
		super(message)
		this.name = name
		this.code = code
	}
}
